import { Table, ValueOrFallback } from "melco-ui";
import { useTranslation } from "react-i18next";
import {
  FormattedDate,
  EfsMelcoEfsModelsRunListItem,
  TableCellLink,
} from "melco-shared-logic";
import { useLogs } from "../../hooks/logs/useLogs";
import { LogStatus } from "./LogStatus";
import { useNavigate } from "react-router-dom";

const DETAIL_VIEW_PATH = "/logs";

export const LogsList: React.FC = () => {
  const { isLoading, isFetching, data, isPreviousData, errorComponent } =
    useLogs();

  const navigate = useNavigate();

  const { t } = useTranslation();

  const columns = [
    {
      title: t("logs_list.columns.computer_name"),
      key: "computer_name",
      dataIndex: "computer_name",
      render: (_: string, item: EfsMelcoEfsModelsRunListItem) => (
        <ValueOrFallback
          value={item.computer_name}
          render={(value) => (
            <TableCellLink to={[DETAIL_VIEW_PATH, item.id].join("/")}>
              {value}
            </TableCellLink>
          )}
          fallback={t("global.fallback.empty")}
        />
      ),
    },
    {
      title: t("logs_list.columns.client_start_time"),
      key: "client_start_time",
      dataIndex: "client_start_time",
      render: (_: string, item: EfsMelcoEfsModelsRunListItem) => (
        <FormattedDate date={item.client_start_time} />
      ),
    },
    {
      title: t("logs_list.columns.jobs"),
      key: "jobs",
      dataIndex: "jobs",
    },
    {
      title: t("logs_list.columns.files"),
      key: "files",
      dataIndex: "files",
    },
    {
      title: t("logs_list.columns.status"),
      key: "status",
      dataIndex: "status",
      render: (_: string, item: EfsMelcoEfsModelsRunListItem) => {
        return item.status && <LogStatus status={item.status} />;
      },
    },
  ];

  return (
    <Table
      showSorterTooltip={false}
      sticky
      loading={isPreviousData ? isFetching : isLoading}
      dataSource={data}
      columns={columns}
      onRow={(row) => {
        return {
          onClick: () => navigate([DETAIL_VIEW_PATH, row.id].join("/")),
        };
      }}
      rowClassName={() => "clickable"}
      rowKey="id"
      noDataMessage={t("logs_list.empty")}
      errorComponent={errorComponent}
    />
  );
};
